import Page from "src/components/Report/Page";
import HeaderFactors from "./components/Factors/HeaderFactors";
import ExplainFactor from "./components/Factors/ExplainFactor";
import SpaceBetweenTables from "./components/Factors/SpaceBetweenTables";
import Table10 from "./components/Factors/Table/Table10";
import Table21 from "./components/Factors/Table/Table21";
import { useState } from "react";
const PageG9 = ({ reload }) => {
  const [khataratNashiAzKar, setKhataratNashiAzKar] = useState("")
  const [sharayeteNamosaedeMohiteKar, setSharayeteNamosaedeMohiteKar] = useState("")
  return (
    <>
      <Page pageNumber={33}>
        <HeaderFactors
          numberFactors="عامل هجدهم"
          titelFactors="خطرات ناشی از کار"
          maxValue="40"
          jsValue={khataratNashiAzKar}
        />
        <ExplainFactor
          text="منظور از این عامل خطراتی نظیر اتفاق، تصادف و صدمه جسمی است که با وجود پیش بینی ضوابط ایمنی و
          احتیاط لازم در حین انجام وظایف رخ می دهد."
        />
        <Table10 setKhataratNashiAzKar={setKhataratNashiAzKar} khataratNashiAzKar={khataratNashiAzKar} reload={reload}/>
        <SpaceBetweenTables />
        <HeaderFactors
          numberFactors="عامل نوزدهم"
          titelFactors="شرایط نامساعد محيط کار"
          maxValue="40"
          jsValue={sharayeteNamosaedeMohiteKar}
        />
        <ExplainFactor
          text="میزان نامطبوع بودن محیط کار به دلیل وجود عوامل ناراحت کننده ای نظیر دود، بخار، گاز، بو، آفتاب، نور،
          گرد وغبار، رطوبت، سرو صدا، گر و سرما، مواد شیمیایی و..."
        />

        <Table21 setSharayeteNamosaedeMohiteKar={setSharayeteNamosaedeMohiteKar} sharayeteNamosaedeMohiteKar={sharayeteNamosaedeMohiteKar} reload={reload}/>
      </Page>
    </>
  );
};

export default PageG9;
